import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.22 14.227a2.83 2.83 0 0 1-2.006-.827 2.833 2.833 0 0 1 0-4.006l1.653-1.647a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .707L6.92 10.1a1.84 1.84 0 0 0 0 2.594 1.84 1.84 0 0 0 2.594 0l2.593-2.594a4.14 4.14 0 0 0 1.22-2.946 4.169 4.169 0 0 0-7.113-2.947L3.387 7.034A3.48 3.48 0 0 0 2.36 9.507a3.48 3.48 0 0 0 1.027 2.473.503.503 0 0 1 0 .707.503.503 0 0 1-.707 0 4.5 4.5 0 0 1-1.32-3.18c0-1.2.467-2.333 1.32-3.18L5.507 3.5a5.175 5.175 0 0 1 7.307 0 5.14 5.14 0 0 1 1.513 3.654c0 1.38-.54 2.68-1.513 3.653L10.22 13.4a2.8 2.8 0 0 1-2 .827"
    }, null, -1)
  ]))]))
}
export default { render: render }